import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import { appNamedRoutes } from '../../routes';
import { getQueryFromState } from '../../utils/query';
import { apTabChanged } from '../../actions/internal';
import { deleteAccountPlayer, updateAccountPlayer, resetCohortsAccountPlayer } from '../../actions/partner';
import { getCohorts } from '../../selectors';
import AccountPlayer from '../../components/accountplayer/AccountPlayer';

const mapStateToProps = (state) => {
  return {
    accountPlayer: state.accountPlayer.player,
    auth: state.auth,
    backLink: { pathname: appNamedRoutes.accountPlayers, search: getQueryFromState(state.meta.accountPlayers, 'accountPlayers') },
    cohorts: getCohorts(state),
    tabIdx: get(state.meta.accountPlayer, 'tabs.idx', 0),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onGoBack: (backLink) => {
      dispatch(push(backLink));
    },
    onUpdate: (id, params) => {
      dispatch(updateAccountPlayer(id, params));
    },
    onDelete: (id) => {
      dispatch(deleteAccountPlayer(id));
    },
    onResetCohorts: (id) => {
      dispatch(resetCohortsAccountPlayer(id)).then(() => {
        dispatch(push(appNamedRoutes.root));
      });
    },
    onClickMore: (tab, anchor) => {
      dispatch(apTabChanged(tab, anchor));
    },
  }
}

const AccountPlayerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountPlayer)

export default AccountPlayerContainer;
